/** #################################### Generated content ####################################
 * This block has been generated with deppy create-index (for more information https://github.com/webedx-spark/deppy)
 **/

export type {
  /**
   * @deprecated - graded-discussion-prompt is intended to be an "application" package that only contains code pertaining to the learner discussion prompt UI. This should be moved to a shared layer e.g. discussion-prompts-common or assess-common
   */
  EvaluationSchema,
} from './types/Assignment';
export type {
  /**
   * @deprecated - graded-discussion-prompt is intended to be an "application" package that only contains code pertaining to the learner discussion prompt UI. This should be moved to a shared layer e.g. discussion-prompts-common or assess-common
   */
  DiscussionPromptEvaluation as Evaluation,
} from './types/Evaluation';
export {
  /**
   * @deprecated - graded-discussion-prompt is intended to be an "application" package that only contains code pertaining to the learner discussion prompt UI. This should be moved to a shared layer e.g. discussion-prompts-common or assess-common
   */
  default as DiscussionPromptState,
} from './models/DiscussionPromptState';
export { default as GradedDiscussionPromptItem } from './components/GradedDiscussionPromptItem';
export const GradedDiscussionPromptItemDynamic = () => import('./components/GradedDiscussionPromptItem');

/**
 *  #################################### Generated content ####################################
 **/
